import React, { useState,useEffect } from "react";
import DailyBalanceReport from "./DailyBalanceReport";
import MonthlyBalanceReport from "./MonthlyBalanceReport";
import { Tabs, Col, Row, Tooltip, message } from "antd";
import { BarsOutlined, FileExcelOutlined } from "@ant-design/icons";
import moment from "moment";
import RequestHandler from "util/RequestHandler";
import { odata, queryHelper } from "../Filters/Helper";
import config from "../../util/ApiforContext";
import { start } from "nprogress";
import { Link, useHistory } from "react-router-dom";

const DayReports = (props) => {
  const history = useHistory();
  const { TabPane } = Tabs;
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [query, setQuery] = useState("");
  const [bankId, setBankId] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [amountMax, setAmountMax] = useState("");
  const [amountMin, setAmountMin] = useState("");
  const [amountMaxEUR, setAmountMaxEUR] = useState("");
  const [amountMaxGBP, setAmountMaxGBP] = useState("");
  const [amountMaxUSD, setAmountMaxUSD] = useState("");
  const [amountMaxAUD, setAmountMaxAUD] = useState("");
  const [amountMinAUD, setAmountMinAUD] = useState("");
  const [amountMaxXAU, setAmountMaxXAU] = useState("");
  const [amountMinXAU, setAmountMinXAU] = useState("");
  const [amountMinEUR, setAmountMinEUR] = useState("");
  const [amountMinGBP, setAmountMinGBP] = useState("");
  const [amountMinUSD, setAmountMinUSD] = useState("");
  const [isExcel, setIsExcel] = useState(false);

  useEffect(() => {
    setActiveTabKey(props.location.search.split("?activeTab=")[1])
  }, [props]);

  const onMonthlyFilterChange = (filterData) => {
   
    if (filterData.amountMax !== "" && filterData.amountMax !== undefined && filterData.amountMax !== null) {
      setAmountMax(filterData.amountMax);
    } else {
      setAmountMax("")
    }
    if (filterData.amountMin !== "" && filterData.amountMin !== undefined && filterData.amountMin !== null) {
      setAmountMin(filterData.amountMin);
    } else {
      setAmountMin("")
    }
    if (filterData.amountMaxEUR !== "" && filterData.amountMaxEUR !== undefined && filterData.amountMaxEUR !== null) {
      setAmountMaxEUR(filterData.amountMaxEUR);
    } else {
      setAmountMaxEUR("")
    }
    if (filterData.amountMaxGBP !== "" && filterData.amountMaxGBP !== undefined && filterData.amountMaxGBP !== null) {
      setAmountMaxGBP(filterData.amountMaxGBP);
    } else {
      setAmountMaxGBP("")
    }
    if (filterData.amountMaxXAU !== "" && filterData.amountMaxXAU !== undefined && filterData.amountMaxXAU !== null) {
      setAmountMaxXAU(filterData.amountMaxXAU);
    } else {
      setAmountMaxXAU("")
    }
    if (filterData.amountMinXAU !== "" && filterData.amountMinXAU !== undefined && filterData.amountMinXAU !== null) {
      setAmountMinXAU(filterData.amountMinXAU);
    } else {
      setAmountMinXAU("")
    }
    if (filterData.amountMaxAUD !== "" && filterData.amountMaxAUD !== undefined && filterData.amountMaxAUD !== null) {
      setAmountMaxAUD(filterData.amountMaxAUD);
    } else {
      setAmountMaxAUD("")
    }
    if (filterData.amountMinAUD !== "" && filterData.amountMinAUD !== undefined && filterData.amountMinAUD !== null) {
      setAmountMinAUD(filterData.amountMinAUD);
    } else {
      setAmountMinAUD("")
    }
    if (filterData.amountMaxUSD !== "" && filterData.amountMaxUSD !== undefined && filterData.amountMaxUSD !== null) {
      setAmountMaxUSD(filterData.amountMaxUSD);
    } else {
      setAmountMaxUSD("")
    }
    if (filterData.amountMinEUR !== "" && filterData.amountMinEUR !== undefined && filterData.amountMinEUR !== null) {
      setAmountMinEUR(filterData.amountMinEUR);
    } else {
      setAmountMinEUR("")
    }
    if (filterData.amountMinGBP !== "" && filterData.amountMinGBP !== undefined && filterData.amountMinGBP !== null) {
      setAmountMinGBP(filterData.amountMinGBP);
    } else {
      setAmountMinGBP("")
    }
    if (filterData.amountMinUSD !== "" && filterData.amountMinUSD !== undefined && filterData.amountMinUSD !== null) {
      setAmountMinUSD(filterData.amountMinUSD);
    } else {
      setAmountMinUSD("")
    }

    if (filterData.bankFilterId !== "") {
      setBankId(filterData.bankFilterId);
    } else {
      setBankId("")
    }
    if ((filterData.endDate !== undefined && filterData.startDate !== undefined) && (filterData.endDate !== null && filterData.startDate !== null)) {
      setEndDate(moment(filterData.endDate).format("DD.MM.YYYY"));
      setStartDate(moment(filterData.startDate).format("DD.MM.YYYY"));
    } else {
      setEndDate("")
      setStartDate("")
    }
    if (filterData.filter !== "") {
      setQuery("isBankMonthly=true&isExcelValue=true&isOdataQuery=true&$filter=" + filterData.filter)
    } else if (filterData.endDate !== null) {
      setQuery("isBankMonthly=true&isExcelValue=true&isOdataQuery=true")
    }
    else {
      setQuery("isBankMonthly=true&isExcelValue=true&")
    }
  };
  const onDailyFilterChange = (filterData) => {
   
    if (filterData.bankFilterId !== "") {
      setBankId(filterData.bankFilterId);
    } else {
      setBankId("")
    }

    if (filterData.amountMax !== "" && filterData.amountMax !== undefined && filterData.amountMax !== null) {
      setAmountMax(filterData.amountMax);
    } else {
      setAmountMax("")
    }
    if (filterData.amountMin !== "" && filterData.amountMin !== undefined && filterData.amountMin !== null) {
      setAmountMin(filterData.amountMin);
    } else {
      setAmountMin("")
    }
    if (filterData.amountMaxEUR !== "" && filterData.amountMaxEUR !== undefined && filterData.amountMaxEUR !== null) {
      setAmountMaxEUR(filterData.amountMaxEUR);
    } else {
      setAmountMaxEUR("")
    }
    if (filterData.amountMaxGBP !== "" && filterData.amountMaxGBP !== undefined && filterData.amountMaxGBP !== null) {
      setAmountMaxGBP(filterData.amountMaxGBP);
    } else {
      setAmountMaxGBP("")
    }
    if (filterData.amountMaxUSD !== "" && filterData.amountMaxUSD !== undefined && filterData.amountMaxUSD !== null) {
      setAmountMaxUSD(filterData.amountMaxUSD);
    } else {
      setAmountMaxUSD("")
    }

    if (filterData.amountMaxXAU !== "" && filterData.amountMaxXAU !== undefined && filterData.amountMaxXAU !== null) {
      setAmountMaxXAU(filterData.amountMaxXAU);
    } else {
      setAmountMaxXAU("")
    }
    if (filterData.amountMinXAU !== "" && filterData.amountMinXAU !== undefined && filterData.amountMinXAU !== null) {
      setAmountMinXAU(filterData.amountMinXAU);
    } else {
      setAmountMinXAU("")
    }
    if (filterData.amountMaxAUD !== "" && filterData.amountMaxAUD !== undefined && filterData.amountMaxAUD !== null) {
      setAmountMaxAUD(filterData.amountMaxAUD);
    } else {
      setAmountMaxAUD("")
    }
    if (filterData.amountMinAUD !== "" && filterData.amountMinAUD !== undefined && filterData.amountMinAUD !== null) {
      setAmountMinAUD(filterData.amountMinAUD);
    } else {
      setAmountMinAUD("")
    }

    if (filterData.amountMinEUR !== "" && filterData.amountMinEUR !== undefined && filterData.amountMinEUR !== null) {
      setAmountMinEUR(filterData.amountMinEUR);
    } else {
      setAmountMinEUR("")
    }
    if (filterData.amountMinGBP !== "" && filterData.amountMinGBP !== undefined && filterData.amountMinGBP !== null) {
      setAmountMinGBP(filterData.amountMinGBP);
    } else {
      setAmountMinGBP("")
    }
    if (filterData.amountMinUSD !== "" && filterData.amountMinUSD !== undefined && filterData.amountMinUSD !== null) {
      setAmountMinUSD(filterData.amountMinUSD);
    } else {
      setAmountMinUSD("")
    }
    if ((filterData.endDate !== undefined && filterData.startDate !== undefined) && (filterData.endDate !== null && filterData.startDate !== null)) {
      setEndDate(moment(filterData.endDate).format("DD.MM.YYYY"));
      setStartDate(moment(filterData.startDate).format("DD.MM.YYYY"));
    } else {
      setEndDate("")
      setStartDate("")
    }
    if (filterData.filter !== "") {
      setQuery("isBankDaily=true&isExcelValue=true&isOdataQuery=true&$filter=" + filterData.filter)
    } else if (filterData.endDate !== null) {
      setQuery("isBankDaily=true&isExcelValue=true&isOdataQuery=true")
    }
    else {
      setQuery("isBankDaily=true&isExcelValue=true&")
    }

    if(filterData.isExcel == true){
      setIsExcel(filterData.isExcel);
      RequestHandler.post(
        `/DailyBalanceReport/ExportExcelAsync`,
        {
          query: query,
          BankId: bankId,
          Email : filterData.email,
          EndDate: endDate,
          StartDate: startDate,
          AmountMax: amountMax,
          AmountMin: amountMin,
          AmountMaxEUR: amountMaxEUR,
          AmountMinEUR:amountMinEUR,
          AmountMaxAUD: amountMaxAUD,
          AmountMinAUD: amountMinAUD,
          AmountMaxXAU: amountMaxXAU,
          AmountMinXAU: amountMinXAU,
          AmountMaxUSD : amountMaxUSD,
          AmountMinUSD: amountMinUSD,
          AmountMaxGBP:amountMaxGBP,
          AmountMinGBP: amountMinGBP
        },
        false
      ).then((response) => {
      });
    }
  };
  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);
 
    RequestHandler.post(
      `/DailyBalanceReport/ExportExcel`,
      {
        query: query,
        BankId: bankId,
        EndDate: endDate,
        StartDate: startDate,
        AmountMax: amountMax,
        AmountMin: amountMin,
        AmountMaxEUR: amountMaxEUR,
        AmountMinEUR:amountMinEUR,
        AmountMaxAUD: amountMaxAUD,
        AmountMinAUD: amountMinAUD,
        AmountMaxXAU: amountMaxXAU,
        AmountMinXAU: amountMinXAU,
        AmountMaxUSD : amountMaxUSD,
        AmountMinUSD: amountMinUSD,
        AmountMaxGBP:amountMaxGBP,
        AmountMinGBP: amountMinGBP
      },
      false
    ).then((response) => {
      hideMessage();
      if (response) {
        window.open(
          `${config.apiUrl
          }/DailyBalanceReport/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> GÜN SONU RAPORU
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <Tabs
        defaultActiveKey="1"
        activeKey={activeTabKey}
        onChange={(activeKey) => {
          setActiveTabKey(activeKey);
          const query = {
            activeTab: activeKey,
          };
      
          const queryString = queryHelper.getQueryFromValues(query);
          history.replace({
            pathname: window.location.pathname,
            search: queryString,
          });
        }}
      >
        <TabPane tab="Gün Bazlı" key="1">
          <DailyBalanceReport onFilterChange={onDailyFilterChange} />
        </TabPane>
        <TabPane tab="Ay Bazlı" key="2">
          <MonthlyBalanceReport onFilterChange={onMonthlyFilterChange} />
        </TabPane>
      </Tabs>
    </>
  )
}
export default DayReports;